// Shared renderer for the "à retravailler" list — used by both the
// défi recap (defi.ts) and the session-end recap (session-end.ts).
// Single source of truth so the two surfaces stay visually identical.
//
// Layout: two-column typographic list (prompt | expected). No arrow,
// no row background — the grid does the alignment and a subtle divider
// separates pairs. We deliberately don't echo the user's wrong attempt
// — re-exposing the wrong answer can reinforce the incorrect memory
// trace; the recap is for imprinting the right answer.

import type { SessionError } from "../types";
import { escapeHtml } from "./html";

export function renderErrorRows(errors: SessionError[]): string {
  return errors
    .map(
      (e) =>
        `<div class="defi-error-row">` +
        `<span class="defi-error-prompt">${escapeHtml(e.prompt)}</span>` +
        `<span class="defi-error-answer">${escapeHtml(e.expected)}</span>` +
        `</div>`,
    )
    .join("");
}
